module.exports = __webpack_public_path__ + "img/9_84.5fcfcef2.png";